export const skillGroups = [
    {
        category: 'Front-end',
        items: ['HTML', 'CSS', 'SASS', 'JavaScript', 'TypeScript', 'React', 'Angular', 'Next.js'],
    },
    {
        category: 'Back-end',
        items: ['PHP', 'Symfony', 'Laravel', 'Node.js', 'PostgreSQL', 'MySQL', 'PHPUnit'],
    },
    {
        category: 'DevOps',
        items: ['Git', 'Docker', 'Linux', 'Nginx', 'GitLab CI/CD', 'GitHub Actions'],
    },
    {
        category: 'Gestion de projet',
        items: ['Jira', 'Monday', 'Kanban'],
    },
]
